import request from '@/utils/request'
const qs = require('qs')

// 站点统计
export function getStationList(params) {
  return request({
    url: '/station/list/stationName',
    method: 'post',
    data: qs.stringify(params)
  })
}
//告警中心-告警中站点统计
export function getAlarmingStationList(params) {
  return request({
    url: '/alarming/stationName/list',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 站点下系统统计
export function getEmsSystem(params, stationId) {
  return request({
    url: `/emsSystem/singleStation/${stationId}`,
    method: 'post',
    data: qs.stringify(params)
  })
}
// 导出
export function downloadFile(params) {
  return request({
    url: '/download/file',
    method: 'post',
    data: qs.stringify(params),
    responseType: 'blob'
  })
}
// 获取客户 website 配置
export function getWebConfig(params) {
  return request({
    url: '/bigScreen/webConfig',
    method: 'post',
    data: qs.stringify(params)
  })
}

// 获取所有的客户
export function getListCustomers(params) {
  return request({
    url: '/user/access/list/customers',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 切换客户id
export function switchCustomer(params) {
  return request({
    url: '/user/access/switch/customer',
    method: 'post',
    data: qs.stringify(params)
  })
}
//获取字典故障配置
export function alarmSuggestion(params) {
  return request({
    url: '/dict/alarm/suggestion',
    method: 'post',
    data: qs.stringify(params)
  })
}
